"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapAirportToSelectItem = exports.mapAccountListItemToSelectItem = void 0;
const mapAccountListItemToSelectItem = (account) => {
    var _a, _b, _c, _d;
    return ({
        value: `${account.id}`,
        label: (_d = (_b = (_a = account.user) === null || _a === void 0 ? void 0 : _a.displayName) !== null && _b !== void 0 ? _b : (_c = account.virtualAccount) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : '',
    });
};
exports.mapAccountListItemToSelectItem = mapAccountListItemToSelectItem;
const mapAirportToSelectItem = (locale) => (airport) => {
    var _a, _b;
    return ({
        value: airport.code,
        label: ((_b = (_a = airport.name) === null || _a === void 0 ? void 0 : _a[locale]) !== null && _b !== void 0 ? _b : airport.code),
    });
};
exports.mapAirportToSelectItem = mapAirportToSelectItem;
//# sourceMappingURL=utils.js.map